import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBnV72lUQO1mN6lNFjQ8GxyYJ6ebA3ILk4",
  authDomain: "sjfm-rental-questionnaire.firebaseapp.com",
  projectId: "sjfm-rental-questionnaire",
  storageBucket: "sjfm-rental-questionnaire.firebasestorage.app",
  messagingSenderId: "171976438035",
  appId: "1:171976438035:web:ba3ef412abd8348c07eae6",
  measurementId: "G-31E9214BMK",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
